<template>
  <div class="animated fadeIn">
    <b-card>
      <template slot="header">
        <i class='fa fa-align-justify'></i> Webshell Data Set

        <span class="float-right">
          * Collect webshells through the crawler
        </span>
      </template>
      <b-tabs v-model="index">
        <b-tab title="User Upload" active>
          <UploadTable v-if="index == 0" ref="upload" @refresh="refresh"/>
        </b-tab>
        <b-tab title="Crawler Upload">
          <CrawlerTable v-if="index == 1" ref="crawler" @refresh="refresh"/>
        </b-tab>
        <b-tab title="Obfuscation Filter">
          <RegexTable v-if="index == 2" ref="regex" @refresh="refresh"/>
        </b-tab>
        <b-tab title="Summary">
          <Summary v-if="index == 3" />
        </b-tab>

      </b-tabs>


    </b-card>
  </div>
</template>

<script>
// import vSelect from 'vue-select';
// import moment from 'moment-timezone';
import DatePicker from 'vue2-datepicker'
import datepicker from '@/f1/custom';
import { api, auth } from '@/f1/service';
import 'vue2-datepicker/index.css';
import config from '@/f1/config'
import moment from 'moment-timezone';

// component
import UploadTable from './Webshell.Upload.vue';
import CrawlerTable from './Webshell.Cralwer.vue';
import RegexTable from './Webshell.Regex.vue';
import Summary from './Webshell.Summary.vue';

const default_opt = () => ({
  perPage: 25,
  currentPage: 1, totalRows: 0,
  sk: '', sv: '', skt: '', opt: {
    created_at_ed: moment().add(1, 'd'),
    created_at_sd: moment().add(1, 'd'),
  }, adv: false,
  pageoptions: [
    { text: '10 rows', value: 10 },
    { text: '25 rows', value: 25 },
    { text: '50 rows', value: 50 },
    { text: '100 rows', value: 100 },
    { text: '200 rows', value: 200 }
  ]
});

export default {
  components: { DatePicker, UploadTable, CrawlerTable, RegexTable, Summary },
  data: () => ({
    summary : { normal: 0, total: 0, done: 0, batch: 0 },
    index: 3,
    family: [
      { text: '-', value: '' },
    ],
    model: {
      family : ''
    },
    dropzone: { bar_value: 0, count: 0, done: 0 },
    dropzoneOptions: {
      url: location.hostname == 'localhost' ? `${config.baseURL}/api/v3/dms/upload/user` : `${location.protocol}//${location.hostname}/api/v3/dms/upload/user`,
      thumbnailWidth: 150,
      maxFilesize: 20, // unit is
      addRemoveLinks: true,
      parallelUploads: 3,
      chunking: false,
      duplicateCheck: true,
      headers: {
        // 'ContentType' : 'application/json',
        'Authorization': 'Bearer ' + auth.token
      },
      dictDefaultMessage: "<i class='fa fa-cloud-upload'></i>UPLOAD ME"
    },
    datepicker,
    so: default_opt(),
    profile: auth.profile
  }),
  computed: {
    startRow() { return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage; },
  },
  methods: {

    resetField() { this.so = default_opt(); this.refresh(); this.so.adv = !this.so.adv },
    reset() { this.so = default_opt(); this.refresh(); },
    refresh() {
      switch (this.index) {
        case 0: this.$refs.upload._list.refresh(); break;
        case 1: this.$refs.crawler._list.refresh(); break;
        case 2: this.$refs.regex._list.refresh(); break
      }
    },
    // getRowCount() { return this.so.totalRows || 0; },
    // getItems(ctx) { return this.load(ctx); },
    async load() {

      try {
        let rs = await api.dms.upload.summary();

        this.summary = Object.assign({}, this.summary, rs)
      } catch (e) { this.$toastr.e(e.data || e); }
    },
    detail(item) { this.$router.push({ name: 'cti_webshell', params: { id: item.id } }); },
  },
  created() { },
  destroyed() { },
  mounted() { },
}
</script>
